function normalizeBillingCycle(value) {
  return value === "yearly" ? "yearly" : "monthly";
}

/**
 * Convert a Firestore Timestamp, epoch-seconds number, epoch-ms number,
 * or ISO string to a JS Date (or null if unparseable).
 */
function toDate(value) {
  if (!value) return null;
  if (typeof value?.toDate === "function") return value.toDate();
  if (typeof value?.seconds === "number") return new Date(value.seconds * 1000);
  if (typeof value === "number") {
    // Firestore sometimes returns epoch-seconds (<= 13 digits)
    return value > 9_999_999_999 ? new Date(value) : new Date(value * 1000);
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function getOwnerPlanState(profile) {
  // ── Cancelled but still inside the paid period ──────────────────────────
  // The user cancelled their renewal but hasn't lost access yet. Keep them
  // on "premium" (with cancelled: true so the UI can show the right badge)
  // until subscriptionEnd passes.
  if (
    profile?.subscriptionPlan === "premium" &&
    profile?.subscriptionCancelled === true
  ) {
    const end = toDate(
      profile?.subscriptionEnd || profile?.nextRecurringChargeDate,
    );
    if (end && end > new Date()) {
      return {
        status: "premium",
        cancelled: true,
        billingCycle: normalizeBillingCycle(
          profile?.subscriptionBillingCycle || profile?.recurringBillingCycle,
        ),
      };
    }
    // Period has expired — fall through to free
  }

  // ── Active premium subscription ─────────────────────────────────────────
  const hasPremiumSubscription =
    (profile?.subscriptionPlan === "premium" &&
      profile?.subscriptionCancelled !== true &&
      profile?.hasActiveSubscription !== false) ||
    profile?.recurringPlan === "premium";

  if (hasPremiumSubscription) {
    return {
      status: "premium",
      cancelled: false,
      billingCycle: normalizeBillingCycle(
        profile?.subscriptionBillingCycle || profile?.recurringBillingCycle,
      ),
    };
  }

  if (profile?.pendingCheckoutSelection?.plan === "premium") {
    return {
      status: "pending",
      cancelled: false,
      billingCycle: normalizeBillingCycle(
        profile.pendingCheckoutSelection.billingCycle,
      ),
    };
  }

  return {
    status: "free",
    cancelled: false,
    billingCycle: null,
  };
}
